import { Socket } from "socket.io-client";
import type { BSON as Oid } from "realm-web";
import { IImages } from "../types";

export interface IChatMessageModel {
  socket: Socket | null;
  socketURL: string;
  serverURL: string;
  chatId: string;
  shipment: string | undefined;
  events: ISocketEvent;

  // startSocketConnection(chat_id: string, shipment?: string): Promise<void>;
  getChatsId(): Promise<string>;
  fetchMessages(message_id: string): Promise<Partial<IMessage>[] | void>;
  sendMessage(message: Partial<IMessage>): Promise<any>;
  updateMessageSeen(chat_id: string, shipment?: string): Promise<void>;
}

export type IMessage = {
  _id?: Oid.ObjectId | string;
  chat_id: Oid.ObjectId | string;
  deleted: boolean;
  seen: boolean;
  source: "DRIVER" | "WAREHOUSE" | "CUSTOMER" | "SALES_REP";
  text: string;
  created_at?: Date | string;
  seen_at?: Date | null;
  deleted_at?: Date | null;
  driver?: string;
  warehouse?: string;
  customer_supplier_id: string;
  contains_images?: boolean;
  contains_location?: boolean;
  location?: { lat: number; long: number };
  shipment: string | null;
  chat_images?: Partial<IImages>[];
  sending?: boolean;
  failed?: boolean;
};

export type IMessagePayload = {
  chat_id: Oid.ObjectId;
  source: "DRIVER" | "WAREHOUSE" | "CUSTOMER" | "SALES_REP";
  text: string;
  created_at: Date | null;
  seen_at?: Date | null;
  deleted_at?: Date | null;
  driver: string;
  warehouse: string;
  contains_images?: boolean;
  contains_location?: boolean;
  location?: { lat: number; long: number };
  shipment?: string | null;
};

export interface ISocketEvent {
  fetch: string;
  create: string;
  updateSeen: string;
}

export enum MESSAGE_SOURCE {
  DRIVER = "DRIVER",
  CUSTOMER = "CUSTOMER",
  WAREHOUSE = "WAREHOUSE",
  SALES_REP = "SALES_REP",
}
